import Vue from "vue";
import axios from "axios";

import Modal from "../vue/components/Modal.vue";
export default {
  init() {
    new Vue({
      components: { Modal },
      el: ".contact-form",
      data() {
        return {
          isLoading: false,
          openModal: false,
          contactRecaptcha: false,
          form: {},
        };
      },

      methods: {
        submit() {
          this.contactRecaptcha = false
          if (grecaptcha.getResponse(contactRecaptcha).length !== 0) {
            this.isLoading = true;
            this.form.grecaptcha = grecaptcha.getResponse(contactRecaptcha);
            axios
              .post(`${LTM.api.url}v1/contact`, this.form)
              .then(({ data }) => {
                this.openModal = true;
                this.form = {};
              })
              .catch((error) => { })
              .then(() => {
                this.isLoading = false;
                grecaptcha.reset(contactRecaptcha)
              });
          } else {
            this.contactRecaptcha = true
          }
        }
      },
    });
  },
  finalize() { },
};
